import { useShallow } from "zustand/react/shallow";

import Button, { ButtonProps } from "ds/components/Button";
import useAssistantPanelAvailable from "hooks/useAssistantPanelAvailable";

import { AssistantPanelConversationEntryPoint } from "../analytics/types";
import useAssistantPanelAnalytics from "../analytics/useAnalytics";
import useAssistantPanelSendPrompt from "../hooks/useSendPrompt";
import { AssistantPanelView } from "../Layout/types";
import useAssistantPanelStore from "../Layout/useStore";

type AssistantPanelAskButtonProps = Omit<ButtonProps, "variant" | "children" | "onPress"> & {
  entryPoint: AssistantPanelConversationEntryPoint;
  /** Prefilled in the composer, not sent. */
  prompt?: string;
};

const AssistantPanelAskButton = ({
  entryPoint,
  prompt,
  ...buttonProps
}: AssistantPanelAskButtonProps) => {
  const isAvailable = useAssistantPanelAvailable();
  const { openPrompt, isChatOpen } = useAssistantPanelSendPrompt();
  const { setIsOpen, switchView } = useAssistantPanelStore(
    useShallow((state) => ({
      setIsOpen: state.setIsOpen,
      switchView: state.switchView,
    }))
  );
  const { trackConversationOpened } = useAssistantPanelAnalytics();

  if (!isAvailable) {
    return undefined;
  }

  const handlePress = () => {
    trackConversationOpened(entryPoint);

    if (prompt) {
      openPrompt(prompt, { newChat: !isChatOpen });
      return;
    }

    switchView(AssistantPanelView.CHAT);
    setIsOpen(true);
  };

  return (
    <Button {...buttonProps} variant="ai" onPress={handlePress}>
      Ask
    </Button>
  );
};

export default AssistantPanelAskButton;
